// Utility functions for TherapistNotesPage

/* ------------------------------------------
   Helper function to compute age from DOB
------------------------------------------ */
export function computeAge(dobString) {
  if (!dobString) return "";
  const dobDate = new Date(dobString);
  if (isNaN(dobDate.getTime())) return "";
  const diffMs = Date.now() - dobDate.getTime();
  const ageDate = new Date(diffMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

/* ------------------------------------------
   Format date for display
------------------------------------------ */
export function formatDate(dateString) {
  if (!dateString) return '';
  const datePart = String(dateString).split('T')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return String(dateString);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric'
  });
}

/* ------------------------------------------
   Determine form type for display
------------------------------------------ */
export function determineFormType(formData) {
  if (!formData || !formData.data_json) return "Client Form";
  
  const dataJson = formData.data_json;
  
  if (dataJson.clientName || dataJson.consentDate || (dataJson.basicInfo && dataJson.basicInfo.name)) {
    return "Intake Form";
  }
  
  if (dataJson.storedFields && Array.isArray(dataJson.storedFields)) {
    return "Acuity Intake";
  }
  
  if (dataJson.basicInfo) {
    return "Manual Intake";
  }
  
  return "Client Form";
}

/* ------------------------------------------
   Helper function to safely get signature data
------------------------------------------ */
export function getSignatureData(form, type) {
  if (!form) return '';
  
  // Check for different possible signature field names based on form structure
  let sigData = '';
  
  if (type === 'consent') {
    // Try all possible field names for consent signature
    sigData = form.consent_signature || 
              form.consentSignatureData || 
              (form.data_json && form.data_json.consentSignatureData) || 
              form.signature || 
              '';
  } else if (type === 'cancel') {
    // Try all possible field names for cancellation signature
    sigData = form.cancel_signature || 
              form.cancelSignatureData || 
              (form.data_json && form.data_json.cancelSignatureData) || 
              form.signature || 
              '';
  } else if (type === 'final') {
    // Try all possible field names for final signature
    sigData = form.final_signature || 
              form.finalSignatureData || 
              (form.data_json && form.data_json.finalSignatureData) || 
              form.signature || 
              '';
  }
  
  return sigData;
}